import { render, staticRenderFns } from "./RationaleEditor.vue?vue&type=template&id=6f88ee1f&scoped=true"
import script from "./RationaleEditor.vue?vue&type=script&lang=js"
export * from "./RationaleEditor.vue?vue&type=script&lang=js"
import style0 from "./RationaleEditor.vue?vue&type=style&index=0&id=6f88ee1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88ee1f",
  null
  
)

export default component.exports